import "./OpenTraderReportDialogComponent.scss";
import template from "./OpenTraderReportDialogComponent.html";
import {IComponentOptions} from "angular";
import {ReportFormat, reportFormatExtension, ReportTypes} from "../../models/ReportType";
import {ReportPeriod, ReportPeriods} from "../../models/ReportPeriod";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {reportPeriod} from "./util/OpenTraderReportDialogComponentUtil";
import {AccountId} from "../../../../../account/types/AccountRecord";
import {DateTimeUtil} from "../../../../../js/util/DateTimeUtil";
import {IsoDate} from "../../../../../pseudo-types/DateTypes";

export const OTReportDialog = "tfOpenTraderReportDialog";

export function otReportDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controllerAs: "ctrl",
        controller: OpenTraderReportDialogComponentController
    };
}

interface Resolve {
    readonly accountId: AccountId;
}

export class OpenTraderReportDialogComponentController {

    /** @input */
    public readonly modalInstance: IModalInstanceService;

    /** @input */
    public readonly resolve: Resolve;

    public readonly reportTypes = ReportTypes;
    public readonly reportPeriods = ReportPeriods;
    public readonly today = DateTimeUtil.isoToday();

    public selectedReport = this.reportTypes[0];
    public selectedPeriod = this.reportPeriods[0];
    public reportDate = DateTimeUtil.isoToday();

    public periodStart: IsoDate;
    public periodEnd: IsoDate;

    public reportFormat = ReportFormat.PDF;
    public reportExtension: string;

    public constructor() {
        this.periodChanged(this.selectedPeriod);
        this.reportExtension = reportFormatExtension(this.reportFormat);
    }

    public get accountId(): AccountId {
        return this.resolve.accountId;
    }

    public periodChanged(period: ReportPeriod) {
        const [start, end] = reportPeriod(period);
        this.periodStart = start;
        this.periodEnd = end;
    }

    public close() {
        this.modalInstance.close();
    }

    public reportFormatChanged(reportFormat: ReportFormat) {
        this.reportExtension = reportFormatExtension(reportFormat);
    }
}
